'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = ['M32 416l0 64 64 0 320 0 64 0 0-64c0-35.3-28.7-64-64-64l-32 0 0-32c0-35.3-28.7-64-64-64c-12.9 0-24.9 3.8-34.9 10.3l-25.9 16.9L241.5 258c-14.5-20.6-38.4-34-65.5-34c-44.2 0-80 35.8-80 80l0 21.5 0 22.6-21.3 7.5C49.8 364.4 32 388.2 32 416zM284.8 196.9c11.2-3.2 23-4.9 35.2-4.9c13.7 0 27 2.2 39.4 6.2C404.5 136.2 477.5 96 560 96l16 0c0-21.3 0-42.7 0-64c-5.3 0-10.7 0-16 0C440.9 32 337.4 98.8 284.8 196.9zm104.1 15.2c18.6 11.9 33.9 28.5 44.3 48.1C460.4 219.1 507 192 560 192l16 0c0-21.3 0-42.7 0-64c-5.3 0-10.7 0-16 0c-69.6 0-131.6 33-171.1 84.1z', 'M284.8 196.9C337.4 98.8 440.9 32 560 32l16 0 0-32L560 0C427.8 0 313.1 74.5 255.5 183.9c7.2 4.8 13.9 10.1 20.1 16c3-1.1 6.1-2.1 9.3-3zm160.4 96.2c1.8 .5 3.6 1.1 5.4 1.6C469.3 253.1 511.3 224 560 224l16 0 0-32-16 0c-53 0-99.6 27.1-126.8 68.2c5.4 10.2 9.5 21.3 12 33zm-56.3-81C428.4 161 490.4 128 560 128l16 0 0-32-16 0c-82.5 0-155.5 40.2-200.6 102.2c10.5 3.4 20.4 8.1 29.5 13.9zM384 320l0 32 32 0c35.3 0 64 28.7 64 64l0 64-64 0L96 480l-64 0 0-64c0-27.8 17.8-51.6 42.7-60.4L96 348.1l0-22.6L96 304c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM0 512l32 0 64 0 320 0 64 0 32 0 0-32 0-64c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 210.8 213.9 192 176 192c-61.9 0-112 50.1-112 112l0 21.5C26.7 338.6 0 374.2 0 416l0 64 0 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;